<template>
  <div>
    <a-table
      class="tableDataTabs biographicalInformationTable"
      bordered
      :columns="tableData.columns"
      :data-source="tableData.data"
      :pagination="tableData.pagination"
    >
      <template slot="actions" slot-scope="text, record">
        <a href="javascript:;" @click="() => showDetail(record)">详情</a>
      </template>
    </a-table>
  </div>
</template>
<script>
export default {
  props: {
    model: Object
  },
  data () {
    return {
      tableData: {
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => {
              return index + 1
            },
            width: 50
          },
          {
            title: '任务编号',
            dataIndex: 'name',
            align: 'left'
          },
          {
            title: '任务名称',
            dataIndex: 'name2',
            align: 'left'
          },
          {
            title: '操作类型',
            dataIndex: 'name3',
            align: 'left'
          },
          {
            title: '出入库类型',
            dataIndex: 'name4',
            align: 'left'
          },
          {
            title: '任务状态',
            dataIndex: 'name5',
            align: 'left'
          },
          {
            title: '创建人',
            dataIndex: 'name6',
            align: 'left'
          },
          {
            title: '操作时间',
            dataIndex: 'name7',
            align: 'left'
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'actions'
            },
            align: 'left'
          }
        ],
        data: [],
        pagination: {
          pageNum: 1,
          pageSize: 10,
          total: 0,
          pageSizeOptions: ['10', '20', '30', '40'],
          showSizeChanger: true,
          showQuickJumper: true
        }
      },
      analogData: []
    }
  },
  watch: {
    model: {
      handler (model) {
        this.initValueDetail(model)
      },
      immediate: true
    }
  },
  methods: {
    initValueDetail () {
      for (let i = 0; i < 99; i++) {
        this.analogData.push(
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          },
          {
            id: 1 + `a${i}`,
            name: '0001',
            name2: 'xxxx',
            name3: '出库',
            name4: '报废出库',
            name5: '审核中',
            name6: '张三',
            name7: '2022-11-11 14;23:23'
          }
        )
      }
      this.tableData.data = this.analogData
    },
    showDetail () {}
  }
}
</script>

<style lang="less" scoped>
.table /deep/ .ant-table-tbody > tr > td {
  padding: 10px;
}
/deep/ .ant-table-thead{
  height: 32px;
  & th{
    background: #E6ECF5;
  }
}
.tableDataTabs /deep/ .ant-table-body {
  border-left: 1px solid #DDDDDD;
}
/deep/.biographicalInformationTable  {
  >.ant-spin-nested-loading {
    >.ant-spin-container {
      >.ant-table-pagination.ant-pagination {
        margin-bottom: 10px !important;
        margin-right: 10px !important;
      }
    }
  }
}
.searchManagement {
  margin: 0 !important;
  .searchInput {
    padding: 10px 0 10px 12px !important;
  }
}
</style>
